(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('vendorAddAction', {
      controller: Controller,
      templateUrl: 'actions/vendor/add/add-vendor.action.html',
      bindings: {
        vendor: '<',
        teamId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
